export default __webpack_public_path__ + "static/media/inter-regular.fc49d131.woff";